import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const aiService = {
    getAllAIs, 
    updateAIStatus,
    getAI,
    updateAI,
    createAI,
  };

const MODULE = {
    AI: 'rnd-active-ingredients',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'AI') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllAIs(filter) {
   
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        name: filter.name,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.AI}`, requestOptions)
}


export function updateAIStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.AI}/${data.id}`, requestOptions)
}

export async function getAI(id) {
  return await apiHelper(API_URL).get(`/${MODULE.AI}/${id}`)
}

export function updateAI(data) {
  const requestOptions = {
    name: data.name,
    is_active: data.isActive,
  }

  return apiHelper(API_URL).put(`/${MODULE.AI}/${data.id}`, requestOptions)
}

export function createAI(data) {
  const requestOptions = {
    name: data.name,
  }
  return apiHelper(API_URL).post(`/${MODULE.AI}`, requestOptions)
}